<div mat-dialog-title>
  <div data-testId="title" class="h4 mb-0">{{data.title}}</div>
  <button data-testId="close" mat-icon-button [mat-dialog-close]="unsavedChangesDialogOptions.Cancel">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
<div data-testId="message" mat-dialog-content class="pb-4">
  <div>{{data.message}}</div>
</div>
<div mat-dialog-actions>
  <button
    data-testId="discard-changes"
    mat-flat-button
    color="warn"
    [mat-dialog-close]="unsavedChangesDialogOptions.Continue"
    cdkFocusInitial
  >
    <mat-icon svgIcon="close"></mat-icon>
    {{continueButtonLabel$ | async}}
  </button>
  <button
    data-testId="save"
    mat-flat-button
    class="mat-secondary"
    [mat-dialog-close]="unsavedChangesDialogOptions.Save"
  >
    <mat-icon svgIcon="content-save"></mat-icon>
    {{data.saveButtonLabel}}
  </button>
  <button data-testId="cancel" mat-button color="primary" [mat-dialog-close]="unsavedChangesDialogOptions.Cancel">
    {{staticMessage.CancelButton | staticMessage}}
  </button>
</div>
